import checkVerifiedCloudBeige from '../../../../assets/checkVerifiedCloudBeige.svg';
import play from '../../../../assets/playBlack.svg';
import star from '../../../../assets/starSharpBlack.svg';
import stop from '../../../../assets/stopBlack.svg';
import { GuideCard as Guide } from '@7chairs/types';
import {
  GuideCardAudioButton,
  GuideCardAudioButtonIcon,
  GuideCardAudioButtonText,
  GuideCardAudioButtonWrapper,
  GuideCardAvatar,
  GuideCardAvatarSection,
  GuideCardContainer,
  GuideCardContent,
  GuideCardContentTexts,
  GuideCardDescription,
  GuideCardLabel,
  GuideCardLabelIcon,
  GuideCardLabelWrapper,
  GuideCardName,
  GuideCardNumberColumn,
  GuideCardNumberColumnStar,
  GuideCardNumberColumnText,
  GuideCardNumberColumnValue,
  GuideCardNumberColumnValueWrapper,
  GuideCardNumbers,
  GuideCardWrapper,
} from './GuideCard.style';

interface GuideCardProps {
  data: Guide;
  index: number;
  isPlaying?: boolean;
  onButtonClick: (index: number) => void;
}

export const GuideCard = (props: GuideCardProps) => {
  const { data, index, isPlaying, onButtonClick } = props;

  const onAudioButtonClick = () => {
    onButtonClick(index);
  };

  return (
    <GuideCardWrapper>
      <GuideCardContainer>
        <GuideCardAvatarSection>
          <GuideCardAvatar src={data.imageUrl} />
        </GuideCardAvatarSection>

        <GuideCardContent>
          <GuideCardContentTexts>
            <GuideCardLabelWrapper>
              <GuideCardLabelIcon src={checkVerifiedCloudBeige} alt="" />
              <GuideCardLabel>{data.label}</GuideCardLabel>
            </GuideCardLabelWrapper>
            <GuideCardName>{data.name}</GuideCardName>
            <GuideCardDescription>{data.description}</GuideCardDescription>
            <GuideCardNumbers>
              <GuideCardNumberColumn>
                <GuideCardNumberColumnValueWrapper>
                  <GuideCardNumberColumnValue>{data.ratingNumber}</GuideCardNumberColumnValue>
                  <GuideCardNumberColumnStar src={star} alt="" />
                </GuideCardNumberColumnValueWrapper>
                <GuideCardNumberColumnText>{data.ratingText}</GuideCardNumberColumnText>
              </GuideCardNumberColumn>

              <GuideCardNumberColumn isMiddle={true}>
                <GuideCardNumberColumnValueWrapper>
                  <GuideCardNumberColumnValue>{data.reviewsNumber}</GuideCardNumberColumnValue>
                </GuideCardNumberColumnValueWrapper>
                <GuideCardNumberColumnText>{data.reviewsText}</GuideCardNumberColumnText>
              </GuideCardNumberColumn>
              <GuideCardNumberColumn>
                <GuideCardNumberColumnValueWrapper>
                  <GuideCardNumberColumnValue>{data.sessionsNumber}</GuideCardNumberColumnValue>
                </GuideCardNumberColumnValueWrapper>
                <GuideCardNumberColumnText>{data.sessionsText}</GuideCardNumberColumnText>
              </GuideCardNumberColumn>
            </GuideCardNumbers>
          </GuideCardContentTexts>

          <GuideCardAudioButtonWrapper>
            <GuideCardAudioButton onClick={onAudioButtonClick}>
              <GuideCardAudioButtonIcon src={isPlaying ? stop : play} />
              <GuideCardAudioButtonText>{data.audioText}</GuideCardAudioButtonText>
            </GuideCardAudioButton>
          </GuideCardAudioButtonWrapper>
        </GuideCardContent>
      </GuideCardContainer>
    </GuideCardWrapper>
  );
};
